export const LoadingDiv = (props) => {
    const {small} = props
    return (
        <div className="flex flex-col gap-4 w-full p-4 lg:mb-0 mb-16">
            <div className="skeleton h-6 w-full"></div>
            <div className="skeleton h-6 w-full"></div>
            {!small && <div className="skeleton h-6 w-full"></div>}
        </div> 
    )
}